import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rpc-not-authorized-user-group',
  templateUrl: './not-authorized-user-group.component.html',
  styleUrls: ['./not-authorized-user-group.component.scss']
})
export class NotAuthorizedUserGroupComponent {
}
